import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import { ic_picture_as_pdf } from 'react-icons-kit/md/ic_picture_as_pdf'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrDatePicker from '../components/FrDatePicker'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import NumberFormat from 'react-number-format'

import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'
import { mCPF } from '../utils/masks'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Financeiro() {
    const [data, setData] = useState([])
    const [filter, setFilter] = useState({})
    const [filtered, setFiltered] = useState(false)
    const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
    const [totalValor, setTotalValor] = useState(0)
    const [totalRecebido, setTotalRecebido] = useState(0)
    const [totalPendente, setTotalPendente] = useState(0)
    const [selected, setSelected] = useState([])
    const [comboCad, setComboCad] = useState([{ value: '', display: '' }])
    const [tipoGrupo, setTipoGrupo] = useState('')

    const columns = [
        { id: 'NOMEASS', numeric: true, label: 'Associado', align: 'left', minWidth: 150 },
        { id: 'PARCELA', numeric: true, label: 'Nº Parcela', align: 'left', minWidth: 50 },
        { id: 'DATA_VENCIMENTO', numeric: false, label: 'Vencimento', align: 'left', minWidth: 75 },
        { id: 'VALOR', numeric: true, NumberFormat: '.#,##', label: 'Valor', align: 'left', minWidth: 75 },
        { id: 'VALOR_LIQUIDADO', numeric: true, label: 'Liquidado', align: 'left', minWidth: 75 },
        { id: 'DATA_LIQUIDACAO', numeric: true, label: 'Data Liquidação', align: 'left', minWidth: 75 },
        // { id: 'PK_CTR', numeric: true, label: 'Cód.Interno', align: 'left', minWidth: 75 },


    ]

    useEffect(() => {
        const fetchData = async () => {
            setTipoGrupo(await api.getTipoGrupo(auth.user))
            console.log(auth.tipo_grupo)
            swal.fire({
                html: <FrLoading text="Carregando..." />,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            })
            if (auth.tipo_grupo == 'P')
                setComboCad(await api.getComboData('cadastro', 'A', 'pk_uex=' + auth.user))
            else
                setComboCad(await api.getComboData('cadastro', 'A'))

            const urlParams = new URLSearchParams(window.location.search);
            let query = paramsToObject(urlParams)
            setFilter(query)
            populateForm(document.getElementById('searchForm'), query)
            swal.close()
            if (query.buscar === 'true') {
                let event = new Event('build');
                getData(event)
            }
        }

        fetchData()
    }, [])

    function getData(e) {
        e.preventDefault()
        console.log()
        var formData = new FormData(document.getElementById('searchForm'))
        var queryObject = formToObject(formData)
        // if (!isEmpty(queryObject)) {
        queryObject.buscar = true
        queryObject.uex = auth.user;
        // queryObject.tipo_grupo =  tipoGrupo;

        setFiltered(true)
        window.history.replaceState({ filtered: true }, 'filter', "/sistema/financeiro?" + objectToQueryString(queryObject));
        swal.fire({
            html: <FrLoading text="Buscando dados..." />,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
        })
        api.get('/financeiro', { params: queryObject }).then(r => {
            console.log(r.data)
            setData(r.data)
            try {
                console.log(r.data[0])
                setTotalValor(r.data[0].TOTAL)
                setTotalRecebido(r.data[0].TOTAL_LIQUIDADO)
                setTotalPendente(r.data[0].TOTAL_PENDENTE)
            } catch { }
            swal.close()
        })
        // } else {
        // swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
        // }
    }

    function clearForm(e) {
        e.preventDefault();
        console.log('limpa');
        window.history.replaceState({ filtered: false }, 'filter', '/sistema/financeiro');
        document.getElementById('searchForm').reset()
        setFilter({})
    }

    const handleChange = (e) => {
        const auxValues = { ...filter };
        switch (e.target.name) {
            case 'cpf':
                auxValues[e.target.name] = mCPF(e.target.value)
                break

            default:
                auxValues[e.target.name] = e.target.value;
                if (typeof (e.target.value) === 'string') auxValues[e.target.name] = e.target.value.toUpperCase()
                break
        }

        setFilter(auxValues);
    };

    function handleBloqueto(e) {
        e.preventDefault()
        let url = "/sistema/bloquetos?pks=" + selected
        window.open(url, '_blank')
    }

    return (
        <div className="Manut">
            <NavBar />
            <div className="ManutContent">
                <div className="defaultHeader">
                    <h1>Financeiro</h1>
                    <UserOptions />
                </div>
                <br />
                <div className="filtersDiv">
                    <form id="searchForm" onSubmit={getData}>
                        <div>
                            <FrDatePicker
                                value={(filter.dataIniVenc || '').split('T')[0]}
                                onChange={handleChange}
                                name="dataIniVenc"
                                id="dataIniVenc"
                                color="#49573B"
                                label="Período de Vencimento"
                                variant="outlined"
                                size="small"
                                style={{ width: 190 }}
                            />
                            <FrDatePicker
                                value={(filter.dataFimVenc || '').split('T')[0]}
                                onChange={handleChange}
                                name="dataFimVenc"
                                id="dataFimVenc"
                                color="#49573B"
                                label=""
                                variant="outlined"
                                size="small"
                                style={{ width: 190 }}
                            />
                            <FrDatePicker
                                value={(filter.dataIniLiq || '').split('T')[0]}
                                onChange={handleChange}
                                name="dataIniLiq"
                                id="dataIniLiq"
                                color="#49573B"
                                label="Período de Liquidação"
                                variant="outlined"
                                size="small"
                                style={{ width: 190 }}
                            />
                            <FrDatePicker
                                value={(filter.dataFimLiq || '').split('T')[0]}
                                onChange={handleChange}
                                name="dataFimLiq"
                                id="dataFimLiq"
                                color="#49573B"
                                label=""
                                variant="outlined"
                                size="small"
                                style={{ width: 190 }}
                            />

                            {['P'].indexOf(tipoGrupo) >= 0 ?
                                <FrSelect
                                    value={filter.associado || ''}
                                    style={{ width: 250 }}
                                    name="associado"
                                    id="associado"
                                    label='Associado'
                                    data={comboCad}
                                    onChange={handleChange}
                                /> : (<></>)}

                        </div>
                        <div>
                            <button onClick={getData}>
                                <Icon icon={ic_search} size={18} />
                                Pesquisar
                            </button>
                            <button onClick={clearForm}>
                                <Icon icon={ic_delete} size={18} />
                                Limpar
                            </button>
                            <button onClick={handleBloqueto}>
                                <Icon icon={ic_picture_as_pdf} size={18} />
                                Emitir Boleto
                            </button>
                        </div>
                    </form>
                </div>
                <br />
                <div className="tableDiv">
                    <FrTable readOnly={true} financeiro regName="financeiro" columns={columns} searched={filtered} codeName="PK_CTR" page={'Financeiro'} data={data} selected={selected} setSelected={setSelected} />
                </div>
                <br />
                <div className="defaultFooter" hidden={data.length === 0}>
                    <h3>
                        <div class="row">
                            <div class="column">
                                TOTAL VALOR
                                <div>
                                    <NumberFormat value={totalValor} fixedDecimalScale={true} decimalScale={2} decimalSeparator={","} thousandSeparator={"."} prefix={'R$'} style={{ backgroundColor: 'transparent', color: 'white', border: 'none' }}></NumberFormat>
                                </div>
                            </div>
                            <div class="column">
                                TOTAL RECEBIDO
                                <div>
                                    <NumberFormat value={totalRecebido} fixedDecimalScale={true} decimalScale={2} decimalSeparator={","} thousandSeparator={"."} prefix={'R$'} style={{ backgroundColor: 'transparent', color: 'white', border: 'none' }}></NumberFormat>
                                </div>
                            </div>
                            <div class="column">
                                TOTAL PENDENTE
                                <div>
                                    <NumberFormat value={totalPendente} fixedDecimalScale={true} decimalScale={2} decimalSeparator={","} thousandSeparator={"."} prefix={'R$'} style={{ backgroundColor: 'transparent', color: 'white', border: 'none' }}></NumberFormat>
                                </div>
                            </div>
                        </div>

                    </h3>
                </div>
                <FooterDelphus />
            </div>
        </div>
    );
}

export default Financeiro;
